module.exports = __webpack_public_path__ + "static/img/Fortitude.df1d91e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Fortitude.jpg
// module id = 1269
// module chunks = 0